var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"contain",staticClass:"rollingContain"},[_c('div',{ref:"content",staticClass:"rollingContent",class:{ inAnimate: _vm.inAnimate }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }